import { SimpleGrid, useDisclosure } from "@chakra-ui/react"
import _ from "lodash"
import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { MODULE_ENROLLMENT_UPLOAD_LOG, PROGRAM_SUBTYPE } from "../../../consts/methods.consts"
import { PROGRAM_SUBTYPE_TAGS, DROPDOWN_TAGS } from "../../../consts/tags.consts"
import { useGetQuery } from "../../../services/api.service"
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable"
import { FormInput } from "../../common/form-controllers/FormInput"
import FormSelect from "../../common/form-controllers/FormSelect"
import PageHeader, { PageHeaderActions } from "../../common/page-header/PageHeader"
import { SectionCard } from "../../common/section-card/SectionCard"
import { useTableDataProvider } from "../../hooks"
import moment from "moment"

const ViewEnrolmentUploadLogs = () => {
    const disclosure = useDisclosure()
    const [page, setPage] = useState(1)
    const navigate = useNavigate()
    const { id } = useParams()

    const { data: _data, isLoading, isFetching } = useGetQuery({
        method: MODULE_ENROLLMENT_UPLOAD_LOG.GET_MODULE_ENROLMENT_LOGS,
        body: {
            id
        },
        providesTags: []
    })

    const data = _.get(_data, 'message', {})
    const lines = _.get(data, 'lines', [])

    const PROGRAM_SUBTYPE_COLUMNS: ChakraTableColumns = [
        {
            header: "Row Number",
            accessor:
                "row_number",
            width: 50
        },
        {
            header: "NIC",
            accessor:
                "nic",
            width: 150
        },
        {
            header: "Status",
            accessor:
                "status",
            width: 150
        },
        {
            header: "Message",
            accessor:
                "message",
        }
    ]

    const actions: PageHeaderActions = [


    ]

    const fakeFormik = {
        values: {
            program_title: _.get(data, 'program_title'),
            module_title: _.get(data, 'module_title'),
            file_name: _.get(data, 'file_name'),
            creation: moment(_.get(data, 'creation')).format('YYYY-MM-DD')
        }
    }

    const onPage = (page: any) => {
        setPage(page)
    }

    return (
        <>
            <div>
                <PageHeader enableBackButton subtitle="View Upload Logs" title={`Upload Logs`} actions={actions} />
                <SectionCard backgroundColor=" bg-white" title="Basic Information" p={3} marginBottom={4}>
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4, xl: 4 }} spacing={3}>
                        <FormInput isDisabled label="File Name" formik={fakeFormik}
                            name="file_name" />
                        <FormInput isDisabled type="date" label="Date" formik={fakeFormik}
                            name="creation" />
                        <FormInput linkTo={`/app/program/${_.get(data, 'program')}`} isDisabled label="Program" formik={fakeFormik}
                            name="program_title" />

                        <FormInput linkTo={`/app/program-module/${_.get(data, 'module')}`} isDisabled label="Module" formik={fakeFormik}
                            name="module_title" />
                    </SimpleGrid>
                </SectionCard>
                <ChakraTable searchable={false} onPage={onPage} isFetching={isFetching} isLoading={isLoading} size={"sm"} header
                    title="Logs"
                    columns={PROGRAM_SUBTYPE_COLUMNS} data={lines} />
            </div>
        </>
    )
}

export default ViewEnrolmentUploadLogs
